/**
 * 公共方法
 */
import publicData from "../store/components/publicData";
import store from "@/store/index";
exports.install = function (Vue,options){
    var _this=Vue.prototype;
    var Common=Vue.prototype.$common={};

    /**
     * 在新页面打开
     * @param {*} $this
     * @param {*} routeName
     * @param {*} param 参数对象，对象格式
     */
    Common.OpenNewPage=function($this,routePath,param){
        let routeData=$this.$router.resolve({
            path:routePath,
            query:param
        });
        window.open(routeData.href,'_blank');
    }
    /**
     * 写入sessionStorage
     */
    Common.setSessionStorage=function(key,objData){
        if(typeof objData=='string'){
            sessionStorage.setItem(key,objData);
        }
        else{
            sessionStorage.setItem(key,JSON.stringify(objData));
        }

    }
    /**
     * 读取sessionStorage
     */
    Common.getSessionStorage=function(key,isObj){
        var data= sessionStorage.getItem(key);
        if(isObj){
            return JSON.parse(data);
        }
        return data;
    },
     /**
     * 移除sessionStorage
     */
    Common.removeSessionStorage=function(key){
        sessionStorage.removeItem(key);
    }
    ,
    Common.timestampToTime =function(row, column) {
          var date = row[column.property];
          if (date == undefined) {
             return "";
          }
        //   return moment(date).format("YYYY-MM-DD HH:mm:ss");
          return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    Common.monthToTime =function(row, column) {
        var date = row[column.property];
        if (date == undefined) {
           return "";
        }
      //   return moment(date).format("YYYY-MM-DD HH:mm:ss");
        return moment(date).format("YYYY-MM");
    },
    Common.minutetampToTime =function(row, column) {
          var date = row[column.property];
          if (date == undefined) {
             return "";
          }
          return moment(date).format("YYYY-MM-DD HH:mm");
    },
    Common.isSuccess =function(data,callback) {
        if (data && data.data) {
            var json = data.data;
            if (json.status == 'SUCCESS') {
                _this.$message({message: '执行成功',type: "success"});
                callback(json);
            }
            else if (json.message) {
                _this.$message({message: json.message,type: "error"});
            }
        }
        else{
            _this.$message({message: '执行异常，请重试',type: "error"});
        }
    },
    Common.datetampToTime=function(val){
        var date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
    var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y+M+D+h+m+s
    },
    Common.monthtampToTime=function(val){
        var date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
        var D = date.getDate()
        return Y+M+D
    },
    Common.mampToTime=function(val){
        var date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1)
        return Y+M
    },

    Common.monthtampToFullTime=function(val){
        var date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
        var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate())
        return Y+M+D
    },

    //时间截止到当前的返回
    // Common.pickerBeginDateBefore=function(){
    //     return {
    //         pickerBeginDateBefore:{
    //                 disabledDate(time){
    //                 return time.getTime() > Date.now()   //如果当天可选，就不用减Date.now()-8.64e7
    //          }
    //        }
    //     }
    // },


    Common.objectToFormData=function (obj, form, namespace) {
        const fd = form || new FormData();
        let formKey;

        for(var property in obj) {
            if(obj.hasOwnProperty(property)) {
              let key = Array.isArray(obj) ? '[]' : `[${property}]`;
              if(namespace) {
                formKey = namespace + key;
              } else {
                formKey = property;
              }

              // if the property is an object, but not a File, use recursivity.
              if(typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                objectToFormData(obj[property], fd, formKey);
              } else {

                // if it's a string or a File object
                fd.append(formKey, obj[property]);
              }

            }
          }

        return fd;

      }



    //图片转化
    Common.imgUrl=function(val){
        if(val){
            return store.state.tradeData.showFile + val
         }else{
             return '/static/img/zanwu2.png'
         }
    },

    // 图片回显
    Common.imgUrlTrans=function(val){
        if(val){
            var urlArray = [];
            val.forEach(item=>{
                let imgObj={
                    name:'图片',
                    url:store.state.tradeData.showFileToken+item+'?token='+window.localStorage.getItem("token_trade_manage")
                }
                urlArray.push(imgObj);
            })
            return urlArray
         }
    },

    //图片转化 带token
    Common.imgUrlTokenFilters=function(val){
        if(val){
            return store.state.tradeData.showFileToken+val+'?token='+window.localStorage.getItem('token_trade_manage')
        }else{
          return '/static/img/zanwu3.png'
        }
    },

    //图片回显处理 数组 带token
    Common.imgArray=function(val,photoIds){
        if(val && photoIds){
            if(val.split(',')){
                var urlArray = [];
                var imgArr = val.split(',');
                var photoIdsArray = photoIds.split(',')
                imgArr.forEach((item,index)=>{
                    let imgObj={
                        name:'图片',
                        photoIds:photoIdsArray[index],
                        url:store.state.tradeData.showFileToken+item+'?token='+window.localStorage.getItem("token_trade_manage")
                    }
                    urlArray.push(imgObj);
                })
            }else{
                var urlArray={
                    name:'图片',
                    photoIds:photoIds,
                    url:store.state.tradeData.showFileToken+val+'?token='+window.localStorage.getItem("token_trade_manage")
                }
            }
            return urlArray
         }
    },


    //图片回显处理 数组 带token
    Common.imgTokenshow=function(val){
        if(val){
            var url = {
                urlArray:[],
                url:null,
            }
            if(val.split(',')){
                var imgArr = val.split(',');
                imgArr.forEach((item)=>{
                    let img = store.state.tradeData.showFileToken + item+'?token='+window.localStorage.getItem("token_trade_manage")
                    url.urlArray.push(img);
                })
                url.url=url.urlArray[0];
            }else{
                var img = store.state.tradeData.showFileToken+ val+'?token='+window.localStorage.getItem("token_trade_manage");
                url.urlArray.push(img);
                url.url = img;
            }
            return url
         }
    },


    //图片回显处理 数组 不带token
    Common.imgShow=function(val,photoIds){
        if(val && photoIds){
            if(val.split(',')){
                var urlArray = [];
                var imgArr = val.split(',');
                var photoIdsArray = photoIds.split(',')
                imgArr.forEach((item,index)=>{
                    let imgObj={
                        name:'图片',
                        photoIds:photoIdsArray[index],
                        url:store.state.tradeData.showFile+item
                    }
                    urlArray.push(imgObj);
                })
            }else{
                var urlArray={
                    name:'图片',
                    photoIds:photoIds,
                    url:store.state.tradeData.showFile+val
                }
            }
            return urlArray
         }
    },
    //图片回显处理 上传  带token
    Common.imgUp=function(val){
        if(val){
            let imgObj={
                name:'图片',
                photoIds:val.content.id,
                url:store.state.tradeData.showFileToken+val.content.pathName+'?token='+window.localStorage.getItem("token_trade_manage")
            }
            return imgObj
         }
    },
    //图片回显处理 上传  不带token
    Common.imgshowFileUp=function(val){
        if(val){
            let imgObj={
                name:'图片',
                photoIds:val.content.id,
                url:store.state.tradeData.showFile+val.content.pathName,
            }
            return imgObj
         }
    },

    //图片文件切换格式回显
    Common.uploadType=function(val){
            let path={
                fileList:[],
                uploadType:null,
            };
            if(val){
                let suffixUrlNum = val.lastIndexOf(".");
                let suffixUrl = val.substring(suffixUrlNum).toLowerCase();
                if (
                    suffixUrl == ".jpg" ||
                    suffixUrl == ".jpeg" ||
                    suffixUrl == ".png" ||
                    suffixUrl == ".gif"
                ) {
                    path.uploadType = "图片";
                } else {
                    path.uploadType = "文件"; //判断是图片还是文件
                }
                if(val.indexOf(',')>=0){
                    path.fileList=[]
                    let isImg=val.split(',')
                    isImg.map((item)=>{
                        let isval={
                            name:'图片名称',
                            url:Common.imgUrlTokenFilters(item),
                        }
                        path.fileList.push(isval)
                    })
                }else{
                    path.fileList=[
                        {
                            name:'图片名称',
                            url:Common.imgUrlTokenFilters(val),
                        }
                    ]
                }
            }

            return path;
    }


    //时间戳
    Common.transdate=function(val){
            var date = new Date(val);
          // 有三种方式获取
             var time1 = date.getTime();
             var time2 = date.valueOf();
             var time3 = Date.parse(date);
         return time1
    }


    //table合并行通用
    Common.mergeTableRow=function(data, merge){
         if (!merge || merge.length === 0) {
            return data
          }
          merge.forEach((m) => {
            const mList = {}
            data = data.map((v, index) => {
              const rowVal = v[m]
              if (mList[rowVal] && mList[rowVal].newIndex === index) {
                    mList[rowVal]['num']++
                    mList[rowVal]['newIndex']++
                    data[mList[rowVal]['index']][m + '-span'].rowspan++
                    v[m + '-span'] = {
                        rowspan: 0,
                        colspan: 0
                    }
                    console.log('1',mList)
              } else {
                    mList[rowVal] = { num: 1, index: index, newIndex: index + 1 }
                    v[m + '-span'] = {
                        rowspan: 1,
                        colspan: 1
                    }
                    console.log('2',mList)
              }
              return v
            })
          })
          return data
    }

     //付款方式
     Common.paymentWayFilter=function(val){
        val = String(val);
        if(val=="1"){
        return "微信"
        }else if(val=="2"){
            return "支付宝"
        }else if(val=='5'){
            return "企业支付宝"
        }else if(val=="6"){
            return "对公"
        }else if(val=="7"){
            return "联合银行(黄功成)"
        }else if(val=="8"){
            return "联合银行(孙玉芝)"
        }else if(val=="9"){
            return "淘宝"
        }else if(val=="10"){
            return "工商银行(对公银行)"
        }else if(val=="11"){
            return "企业微信"
        }else if (val == "12") {
            return "农业银行(爱华对公)"
        } else if (val == "13") {
            return "支付宝(爱华)"
        }else{
          return "/"
        }
    }

    //让按钮失焦事件、
    Common.clickHandler=function(evt){
        let target = evt.target;
        if(target.nodeName == "SPAN"){
            target = evt.target.parentNode;
        }
        target.blur();
    }
    /**
     * 防抖
     * @param {Function} func 要执行的回调函数
     * @param {Number} wait 延时的时间
     * @param {Boolean} immediate 是否立即执行
     * @return null
     */
     let timeout;
     Common.Debounce = (func, wait=300, immediate = false) => {
       // 清除定时器
       if (timeout !== null) clearTimeout(timeout);
       // 立即执行，此类情况一般用不到
       if (immediate) {
         var callNow = !timeout;
         timeout = setTimeout(function() {
           timeout = null;
         }, wait);
         if (callNow) typeof func === 'function' && func();
       } else {
         // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
         timeout = setTimeout(function() {
           typeof func === 'function' && func();
         }, wait);
       }
     }
     /**
      * 节流
      * @param {Function} func 要执行的回调函数
      * @param {Number} wait 延时的时间
      * @param {Boolean} immediate 是否立即执行
      * @return null
      */
     let timer, flag;
     Common.throttle = (func, wait = 300, immediate = true) => {
       if (immediate) {
         if (!flag) {
           flag = true;
           // 如果是立即执行，则在wait毫秒内开始时执行
           typeof func === 'function' && func();
           timer = setTimeout(() => {
             flag = false;
           }, wait);
         }
       } else {
         if (!flag) {
           flag = true
           // 如果是非立即执行，则在wait毫秒内的结束处执行
           timer = setTimeout(() => {
             flag = false
             typeof func === 'function' && func();
           }, wait);
         }
       }
     }
     // 下载文件
     Common.downFile = (path) => {
        var downLoadEle = document.createElement("a");
        downLoadEle.href = Common.imgUrlTokenFilters(path);
        downLoadEle.target = '_blank'
        downLoadEle.download = "附件.pdf";
        document.body.appendChild(downLoadEle);
        downLoadEle.click();
        document.body.removeChild(downLoadEle);
    }


}



// WEBPACK FOOTER //
// ./src/common/util.js